import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const QnaModal = ({ open, handleCloseQnaModal, openedQnaData, handleNext }) => {
  const [selectedOpts, setSelectedOpts] = useState([]);

  const questionAnswerStatementCollection = (
    event,
    optionData,
    isMultiChoice,
    allOpts
  ) => {
    const checked = event.target.checked;
    const suggestion = optionData.suggestion.replaceAll(
      "{{NAME}}",
      openedQnaData.clientName
    );
    if (isMultiChoice) {
      if (checked) {
        setSelectedOpts((prev) => [...prev, suggestion]);
      } else {
        setSelectedOpts((prev) => prev.filter((item) => item !== suggestion));
      }
    } else {
      const allOptVals = allOpts.map((item) =>
        item.suggestion.replaceAll("{{NAME}}", openedQnaData.clientName)
      );
      setSelectedOpts((prev) => {
        const filteredOpts = prev.filter((item) => !allOptVals.includes(item));
        return [...filteredOpts, suggestion];
      });
    }
  };

  const handleNextClick = () => {
    handleNext("careplan", openedQnaData?.catData, { qnaData: selectedOpts });
  };

  return (
    <>
      <Modal
        className="viewModal"
        show={open}
        size="lg"
        onHide={handleCloseQnaModal}
      >
        <div className="predefineTemplate">
          <Modal.Body>
            <div className="col-md-12">
              <h5>{openedQnaData.name}</h5>
              <p>Please answer below questions</p>
              <p>
                Click Next when you finish answering. Your input will be used to
                auto-fill the observations section which you can accordingly
                edit, complete and save in the plan.{" "}
              </p>
              <button
                className="btn nextBtn"
                type="button"
                onClick={handleNextClick}
              >
                Next
              </button>
            </div>
            <div className="col-md-12">
              {openedQnaData?.allQuestionswithAnswers?.map(
                ({ questions, options, _id }, index) => {
                  return (
                    <>
                      {questions.includes("(you can select more than one)") && (
                        <div className="quationBox">
                          <h5>
                            {questions.replaceAll(
                              "{{NAME}}",
                              openedQnaData.clientName
                            )}{" "}
                          </h5>
                          <ul>
                            {options.map((option) => {
                              return (
                                <li>
                                  {/* <label className="checkbox active"> */}
                                  <label
                                    className={`checkbox ${
                                      Object.keys(option).includes(
                                        "answerValue"
                                      ) && option?.answerValue
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <input
                                      type="checkbox"
                                      name={_id}
                                      onChange={(event) => {
                                        questionAnswerStatementCollection(
                                          event,
                                          option,
                                          true,
                                          options
                                        );
                                      }}
                                    />
                                    <span className="checkmark"></span>
                                    {option.answer.replaceAll(
                                      "{{NAME}}",
                                      openedQnaData.clientName
                                    )}
                                  </label>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}

                      {/*question that have single select  */}
                      {!questions.includes(
                        "(you can select more than one)"
                      ) && (
                        <div className="quationBox">
                          <h5>
                            {questions.replaceAll(
                              "{{NAME}}",
                              openedQnaData.clientName
                            )}{" "}
                          </h5>
                          <ul>
                            {options.map((option) => {
                              return (
                                <li>
                                  {/* <label className="checkbox active"> */}
                                  <label
                                    className={`checkbox ${
                                      Object.keys(option).includes(
                                        "answerValue"
                                      ) && option?.answerValue
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <input
                                      type="radio"
                                      name={_id}
                                      onChange={(event) => {
                                        questionAnswerStatementCollection(
                                          event,
                                          option,
                                          false,
                                          options
                                        );
                                      }}
                                    />
                                    <span className="checkmark"></span>
                                    {option.answer.replace(
                                      "{{NAME}}",
                                      openedQnaData.clientName
                                    )}
                                  </label>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </>
                  );
                }
              )}
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default QnaModal;
